module.exports = require("@splunk/visualizations-shared/SanitizeProps");